<template>
    <div class="users_filter">
        <b-modal id="users_filter" v-bind:no-close-on-backdrop=true dialogClass="modal-dialog-right modal-lg" bodyClass="p-0" :hide-footer=true :hide-header=true
                 v-model="is_show_modal" size="xl"
        >
            <template v-slot:modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>

            <div>
                <div id="panel_user_list" class="panel mb-0">
                    <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0 pt-2">
                        <h2>
                            {{__t('CHOOSE_GROUP')}}
                        </h2>

                        <div class="panel-toolbar pr-3 mr-2 align-self-end">
                            <ul id="demo_panel-tabs" class="nav nav-tabs border-bottom-0" >
                                <li class="nav-item cursor-pointer" v-on:click="setTab(0)">
                                    <a class="nav-link " :class="{'active' : tabIndex === 0}" >
                                        {{__t('GROUP_LIST')}}
                                    </a>
                                </li>
                                <li class="nav-item cursor-pointer" v-on:click="setTab(1)">
                                    <a class="nav-link" :class="{'active' : tabIndex === 1}">
                                        {{__t('GROUP_SEARCH')}}
                                    </a>
                                </li>
                            </ul>
                            <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed pl-2" v-on:click="close()">
                                <i class="fal fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div class="panel-container show">
                        <div class="panel-content">
                            <search v-if="tabIndex === 1"></search>
                            <modifiers_groups_filter v-if="tabIndex === 0"></modifiers_groups_filter>
                        </div>
                    </div>
                </div>

                <div class="panel-content py-2 rounded-bottom border-faded border-left-0 border-right-0 border-bottom-0 text-right w-100 position-absolute pos-bottom">
                    <button class="btn btn-lg btn-outline-primary waves-effect waves-themed mr-3 "  type="button"  @click.prevent="close_filter()">
                        <span  class="fal fa-check mr-1"></span>
                        {{__t('ADD')}}
                    </button>

                    <b-button size="xl" variant="outline-warning" @click.prevent="close()"  class="btn btn-lg  waves-effect waves-themed mr-3">
                        <i class="fal fa-times mr-1"></i>
                        {{__t('CLOSE')}}
                    </b-button>
                </div>
            </div>

            <template slot="modal-footer" slot-scope="{ ok, cancel }">
                <b-spinner variant="success" v-if="show_action"></b-spinner>
                <b-button size="xl" variant="success" @click.prevent="close_filter()">
                    {{__t('ADD')}}
                </b-button>
            </template>

        </b-modal>
    </div>
</template>

<script>

import {createHelpers} from 'vuex-map-fields';
const {mapFields} = createHelpers({
    getterType: 'groups/getUfilterField',
    mutationType: 'groups/updateUfilterField',
});


import search from "./tabs/search.vue";
import modifiers_groups_filter from "./tabs/modifiers_groups_filter.vue";

export default {
    name: "group_choose",

    components : {
        search,
        modifiers_groups_filter
    },

    data() {
        return  {
            uniq_call : "modifer_group_filter",
            is_show_modal : false,
            tabIndex : 0,
            groups : [],
            exclude :[],
            is_load : false,
        }
    },

    created() {

        this.$store.dispatch('groups/SET_ACTIVE_EXCLUDE', []);

        EventBus.$on('groups_filter', e => {
            console.log('event_filter',e);
            if(e !== undefined) {
                this.$store.dispatch('groups/SET_ACTIVE_GROUPS_LIST', []);

                if (this.obj_to_null(e.exclude)) {

                    this.$store.dispatch('groups/SET_ACTIVE_EXCLUDE', e.exclude);
                }

                if (this.obj_to_null(e.active)) {
                    let active_list = JSON.parse(JSON.stringify( e.active))
                    this.$store.dispatch('groups/SET_ACTIVE_GROUPS_LIST', active_list);
                }

                if (this.obj_to_null(e.filter_type)) {
                    this.$store.dispatch('groups/SET_FILTER_TYPE', e.filter_type);
                }


                if (this.obj_to_null(e.uniq)) {
                    this.uniq_call = e.uniq
                }
            }
            this.is_show_modal = true;
        });

        EventBus.$on('close_group_filter', e => {
            this.$store.dispatch('groups/CLEAN');
            setTimeout(() =>  this.is_show_modal = false, 500);
        });



    },

    methods : {

        setTab(tabIndex) {
            this.tabIndex = tabIndex;
        },

        close() {
            this.is_show_modal = false;
        },

        close_filter () {
            this.show_action = true;

            if(this.active_groups.length > 0) {
                let send = JSON.parse(JSON.stringify( this.active_groups));
                EventBus.$emit('selected_groups',{
                    groups: send,
                    uniq:this.uniq_call
                });
            }

            else {
                EventBus.$emit('selected_groups',{
                    groups: [],
                    uniq:this.uniq_call
                });
            }

            this.$store.dispatch('groups/CLEAN');
            setTimeout(() =>  this.show_action = false, 500);
        },
    },

    computed: {
        ...mapFields([
            'active_groups'
        ]),
    },
}
</script>


<style scoped>

</style>
